import React, { useState, useEffect } from "react";
import css from './CustomListingsDisplay.module.css';
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useRouteConfiguration } from "../../context/routeConfigurationContext";
import SearchResultsPanel from "../../containers/SearchPage/SearchResultsPanel/SearchResultsPanel";
import { postQueryListings } from "../../util/api";
import Button from "../Button/Button";
import Spinner from "../IconSpinner/IconSpinner";
import { FormattedMessage } from "react-intl";
import { types as sdkTypes } from '../../util/sdkLoader';
import { useConfiguration } from "../../context/configurationContext";

const CustomListingsDisplay = (props) => {
    const { search } = props;

    const [listings, setListings] = useState([])
    const [loading, setLoading] = useState(false)

    const location = useLocation();
    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();
    const config = useConfiguration();
    const { Money } = sdkTypes;
    const listingTypes = config.listing.listingTypes.filter(l => l.listingType !== "admin-adverts" && l.listingType !== "buying").map(l => l.listingType).join(",");

    function getUrlParams(queryString) {
        queryString = queryString.startsWith('?') ? queryString.slice(1) : queryString;

        const pairs = queryString.split('&');
        const params = {};

        for (const pair of pairs) {
            const [key, value] = pair.split('=');
            const decodedKey = decodeURIComponent(key);
            let decodedValue = decodeURIComponent(value || '');

            if (decodedKey === 'price') {
                decodedValue = decodedValue
                    .split(',')
                    .map(v => (parseFloat(v) * 100).toString())
                    .join(',');
            }

            params[decodedKey] = decodedValue;
        }

        return params;
    }

    const fetchListings = async () => {
        try {
            setLoading(true);
            const params = getUrlParams(search)
            const mergedParams = { ...params, pub_listingType:listingTypes } 
            const response = await postQueryListings({ mergedParams });
            const getRelationshipFromIncluded = (relationshipId) => {
                return response.data.included.find(({ id }) => id.uuid === relationshipId)
            }
            const listings = response.data.data.map(listing => {
                if (listing?.attributes?.price) {
                    listing.attributes.price = new Money(listing.attributes.price.amount, listing.attributes.price.currency);
                }
                const { relationships, ...otherListingFields } = listing;
                const images = relationships.images.data.map(image => getRelationshipFromIncluded(image.id.uuid));
                const author = getRelationshipFromIncluded(relationships?.author?.data?.id?.uuid)
                const currentStock = getRelationshipFromIncluded(relationships?.currentStock?.data?.id?.uuid)
                return {
                    ...otherListingFields,
                    images,
                    author,
                    currentStock,
                };
            })
            setListings(listings);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching listings:", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchListings()
    }, [search]);

    return <div className={css.container}>
        {loading ? <div className={css.centerAlign}>
            <Spinner />
        </div> :
            listings.length > 0 ? <>
                <SearchResultsPanel
                    className={css.searchListingsPanel}
                    listings={listings}
                    isMapVariant={false}
                    location={location}
                    history={history}
                    routeConfiguration={routeConfiguration}
                    removeAds={true}
                />
                <Button onClick={() => {
                    history.push(`/annonser?${search}`);
                }}><FormattedMessage id="CustomListingsDisplay.viewMore" /></Button>
            </> : <div className={css.centerAlign}>
                <p><FormattedMessage id="CustomListingsDisplay.noResultsFound" /></p>
                <Button onClick={() => {
                    history.push("/annonser");
                }}><FormattedMessage id="CustomListingsDisplay.viewOtherListings" /></Button>
            </div>
        }

    </div>
};

export default CustomListingsDisplay;